<template>
  <div>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="visible"
      :confirmLoading="confirmLoading"
      :footer="null"
      :maskClosable="false"
    >
      <a-form :form="form" :class="status == 1 ? 'readyOnly' : ''">
        <a-form-item style="display: none">
          <a-input v-decorator="['modelId']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品类别">
          <a-select
            v-decorator="['installType', { rules: [{ required: true, message: '请选择产品类别' }] }]"
            @change="handleSelect"
          >
            <a-select-option v-for="type in restaurantTypes" :key="type.code">{{ type.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="品牌名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            showSearch
            optionFilterProp="children"
            @change="handleChange"
            :filterOption="filterOption"
            v-decorator="['brandId', { rules: [{ required: true, message: '请输入品牌名称' }] }]"
          >
            <a-select-option v-for="item of data2" :key="item.brandId" :value="item.brandId">{{
              item.brandName
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="型号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['modelName', { rules: [{ required: true, message: '请输入型号' }] }]" />
        </a-form-item>
        <a-form-item label="安装难度得分" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select v-decorator="['installScore']" allowClear="true">
            <a-select-option v-for="(type, i) in numArr" :key="i + 1">{{ type }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="版本号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <!--        <a-input  v-model="queryParam.accessoryName"/>-->
          <a-input v-decorator="['modelVer']" />
        </a-form-item>
        <a-form-item label="规格（长度）(mm)" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['specLength']" placeholder="请输入规格（长度）(mm)" />
        </a-form-item>
        <a-form-item label="规格（宽度）(mm)" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['specWidth']" placeholder="请输入规格（宽度）(mm)" />
        </a-form-item>

       
        <a-form-item label="订单类型金额" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="store.getters.userType=='00'">
          <a-row :gutter="10" v-for="(item,index) in orderArr">
            <a-col :span="10">
              <a-select v-model="item.orderTypeId" allow-clear style="width: 100%"  placeholder="请选择订单类型" @change="changeOrderType">
                <a-select-option v-for="i in orderTypeArr" :key="i.orderTypeId">
                  {{ i.typeName }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="10">
              <a-input-number style="width: 100%;" id="inputNumber" v-model="item.price" placeholder="请输入金额" precision="0" min="0" />
            </a-col>
            <a-col :span="2"><a-icon type="plus" @click="changeOrder(1,index)" v-if="index==(orderArr.length-1)"/></a-col>
            <a-col :span="2"><a-icon type="minus" @click="changeOrder(2,index)" v-if="index!=0"/></a-col>
          </a-row>  
        </a-form-item>
        


        <a-row v-if="status != 1">
          <a-col :span="12" :offset="10">
            <!--          <router-link :to="{ name: 'SaveModal' }">-->
            <a-button type="primary" @click="getSave">保存</a-button>
            <!--          </router-link>-->
            <a-button style="margin-left: 8px" @click="showModal">取消</a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
      title="配置"
      style="top: 20px"
      :width="800"
      v-model="disable"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      :maskClosable="false"
    >
      <a-form :form="form">
        <a-row>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业名称" style="width: 410px">
              <a-input-search enter-button @search="onSearch" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div>
        <span style="margin-left: 15%"> 企业配置 : </span>
        <a-tree
          checkable
          v-model="checkedKeys"
          :expanded-keys="expandedKeys"
          :auto-expand-parent="autoExpandParent"
          :defaultExpandedKeys="['enterprise']"
          @expand="onExpand"
          :treeData="dataList"
          :defaultCheckedKeys="checkedKeys"
          style="margin-left: 20%"
          @check="onCheck"
        >
          <template slot="title" slot-scope="{ title }">
            <span v-if="title.indexOf(searchValue) > -1">
              {{ title.substr(0, title.indexOf(searchValue)) }}
              <span style="color: #f50">{{ searchValue }}</span>
              {{ title.substr(title.indexOf(searchValue) + searchValue.length) }}
            </span>
            <span v-else>{{ title }}</span>
          </template>
        </a-tree>
      </div>
    </a-modal>
  </div>
</template>
<script>
import {
  selectModelEnterprise,
  saveModel,
  getModelList,
  getSelectBrand,
  getSelectTree,
  relateModelEnterprise,
} from '@/api/enterprise/model'
import { getEnterprise, getOrderType, getOrderPrincipal } from '@/api/order/common'

import pick from 'lodash.pick'
import { getDictMap } from '../../../utils/dict'
import store from '@/store'

const treeData = []

export default {
  name: 'ModelModal',
  props: {},
  components: {
    // Advanced
  },
  data() {
    return {
      store,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      disable: false,
      visible: false,
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this),
      restaurantTypes: [],
      data2: [],
      queryParam: {},
      // 树状图********************************
      expandedKeys: ['enterprise'], //受控展开的树节点
      checkedKeys: [], //复选
      // selectedKeys: [],
      treeData,
      text: '',
      searchValue: '',
      autoExpandParent: true,
      modelId: '',
      numArr: [],
      dataList: [],
      status: 0,
      treeList: [
        {
          title: '',
          key: '',
          children: '',
        },
      ], // 筛选后的值
      orderArr: [
        {orderTypeId:'',price:''}
      ],
      orderTypeArr:[],//订单类型

    }
  },
  async created() {
    this.restaurantTypes = []
    this.restaurantOperTypeMap = await getDictMap('install_type')
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes.push({ code: key, label: value })
    })
    for (var i = 1; i < 11; i++) {
      // console.log(i)
      this.numArr.push(i)
    }
  },
  methods: {
    changeOrderType() {
      console.log(this.orderArr,'orderArr')
    },
    changeOrder(type,index) {
      // this.queryParams.ruleDetails.push(data);
      if (type == 1) {
        this.orderArr.push({orderTypeId:'',price:''})
      } else {
        this.orderArr.splice(index, 1)
      }
    },
    handleSelect(value) {
      // console.log(value)
      // console.log(store.getters)
      this.form.setFieldsValue({ brandId: '' })
      getSelectBrand({ installType: value, enterpriseId: store.getters.enterpriseId }).then((res) => {
        this.data2 = res.data
      })
      getOrderType(value).then(res => {
        this.orderTypeArr=res.rows
      })

    },
    // 取消
    showModal() {
      this.visible = false
      this.form.resetFields()
      this.orderArr = [{ orderTypeId: '', price: '' }]
    },
    handleChange(value) {
      // console.log(`selected ${value}`)
      this.queryParam.brandId = value
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    add(parentId) {
      this.form.resetFields()
      this.data2 = []
      this.edit({ modelId: 0 })
      // this.edit({ modelId: 0, brandId: parentId || 0 })
    },
    edit(record, status) {
      this.status = status
      this.mdl = Object.assign(record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.mdl,
            'installScore',
            'modelId',
            'installType',
            'brandId',
            'brandName',
            'modelName',
            'modelVer',
            'specLength',
            'specWidth',
            'delFlag',
            'forbiddenStatus',
            'createBy',
            'createTime',
            'updateBy',
            'updateTime'
          )
        )
        getOrderType(record.installType).then(res => {
          this.orderTypeArr=res.rows
        })
        let item = JSON.parse(JSON.stringify(record))
        this.orderArr=item.modelPriceDtoList.length!=0?item.modelPriceDtoList:[{orderTypeId:'',price:''}]
        if (this.mdl.modelId != 0)
          getSelectBrand({ installType: record.installType, enterpriseId: store.getters.enterpriseId }).then((res) => {
            console.log(res)
            this.data2 = res.data
          })
      })
    },
    onSearch(value) {
      let arr = []
      console.log(value)
      if (value != '') {
        let children = this.treeData[0].children
        // console.log(children)
        for (var i in children) {
          // console.log(children[i])
          let title = children[i].title
          if (title.indexOf(value) != -1) {
            // console.log('sk',i,children[i])
            arr.push(children[i])
          }
        }
        console.log(arr)
        ;(this.treeList[0].title = '企业'), (this.treeList[0].key = 'enterprise')
        this.treeList[0].children = arr
        // console.log(this.treeList)
        this.dataList = this.treeList
      } else {
        this.dataList = this.treeData
      }
      this.$nextTick(() => {
        selectModelEnterprise({ modelId: this.modelId }).then((res) => {
          console.log(res)
          this.checkedKeys = res.data
        })
      })
    },
    deploy(record) {
      this.disable = true
      this.modelId = record.modelId
      getSelectTree().then((res) => {
        // console.log(res.data)
        this.treeData = res.data
        this.dataList = this.treeData
        // const data = res.data
        // this.buildtree(data, this.treeData, 0)
        // this.expandedKeys = data.map(m => m.key)
        // this.dataList = data.map(m => {
        //   return { key: m.key, title: m.title }
        // })
      })
      selectModelEnterprise({ modelId: record.modelId }).then((res) => {
        // console.log(res)
        this.checkedKeys = res.data
      })
    },
    getSave(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values)
          this.confirmLoading = true
          if (store.getters.userType == '00') {
            let arr=this.orderArr.filter(obj => {
              return !(!obj.orderTypeId) ||
                    !(!obj.price);
            });

            const hasSinglePropertyWithValue = this.orderArr.some(obj => {
              return (!obj.orderTypeId) !==
                    (!obj.price);
            });

            console.log(arr,'arr',hasSinglePropertyWithValue);
            if (!hasSinglePropertyWithValue) {
              values.modelPriceDtoList=arr
              saveModel(values)
              .then((res) => {
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.visible = false
                  this.form.resetFields()
                  this.checkedKeys = []
                  if (values.modelId == 0 && store.getters.userType != 22) {
                    this.disable = true
                    this.modelId = res.data
                    getSelectTree().then((res) => {
                      // console.log(res.data)
                      this.treeData = res.data
                      this.dataList = this.treeData
                    })
                    this.$emit('ok', 1)
                  } else {
                    this.$emit('ok', 2)
                  }
                } else {
                  this.$message.success(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
              .finally(() => {
                this.confirmLoading = false
              })
            } else {
              this.$message.error('订单类型金额请填写完整')
              
            }
            
          } else {
            saveModel(values)
            .then((res) => {
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.visible = false
                this.form.resetFields()
                this.checkedKeys = []
                if (values.modelId == 0 && store.getters.userType != 22) {
                  this.disable = true
                  this.modelId = res.data
                  getSelectTree().then((res) => {
                    // console.log(res.data)
                    this.treeData = res.data
                    this.dataList = this.treeData
                  })
                  this.$emit('ok', 1)
                } else {
                  this.$emit('ok', 2)
                }
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
          }
          
        }
      })
    },
    // 树状图*********************************
    // 展开/收起节点时触发
    onExpand(expandedKeys) {
      // console.log('onExpand', expandedKeys);
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onCheck(checkedKeys) {
      // console.log('onCheck', checkedKeys);
      this.checkedKeys = checkedKeys
    },
    // ************************************************
    handleSubmit() {
      if (this.checkedKeys.length != 0) {
        this.confirmLoading = true
        relateModelEnterprise({ enterpriseIds: this.checkedKeys, modelId: this.modelId })
          .then((res) => {
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.disable = false
              if (this.modelId == 0) {
                this.$emit('ok', 1)
              } else {
                this.$emit('ok', 2)
              }
              // console.log(this.checkedKeys)
              this.checkedKeys.splice(0, this.checkedKeys.length)
            } else {
              this.$message.success(res.msg)
            }
          })
          .catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
          .finally(() => {
            this.confirmLoading = false
          })
      } else {
        this.$message.error('请选择企业！')
      }
    },
  },
  watch: {
    checkedKeys(val) {
      // console.log('onCheck', val);
      this.checkedKeys = val
      // console.log(this.checkedKeys)
    },
  },
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px !important;
}
.readyOnly {
  pointer-events: none;
}
</style>
